import { isPhoneInput, sanitizePhoneInput } from '@/lib/phone'
import * as React from "react"

import { cn } from "@/lib/utils"
import { DateTimeInput } from "@/components/ui/date-time-input"

const Input = React.forwardRef(({ className, type, inputKind, ...props }, ref) => {
  if (["date", "time", "datetime-local"].includes(type)) {
    return <DateTimeInput ref={ref} type={type} className={className} {...props} />
  }
  const phone = isPhoneInput({ ...props, type, inputKind });
  const onChange = event => {
    if (phone) event.target.value = sanitizePhoneInput(event.target.value);
    props.onChange?.(event);
  };
  return (
    <input
      type={type}
      className={cn(
        "block h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base leading-5 shadow-sm ring-inset transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        type === "file" && "cursor-pointer file:cursor-pointer",
        className
      )}
      ref={ref}
      {...props}
      inputMode={phone ? 'tel' : props.inputMode}
      onChange={onChange} />
  );
})
Input.displayName = "Input"

export { Input }
